import { render, staticRenderFns } from "./HomeTopCollections.vue?vue&type=template&id=636fe00a&scoped=true"
import script from "./HomeTopCollections.vue?vue&type=script&lang=js"
export * from "./HomeTopCollections.vue?vue&type=script&lang=js"
import style0 from "./HomeTopCollections.vue?vue&type=style&index=0&id=636fe00a&prod&scoped=true&lang=css"
import style1 from "./HomeTopCollections.vue?vue&type=style&index=1&id=636fe00a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fe00a",
  null
  
)

export default component.exports